import { ListGroup, Popover } from "react-bootstrap";
import {
  AiFillCloseCircle,
  AiFillEdit,
  AiFillPrinter,
  AiOutlineDiff,
  AiOutlineSafety,
} from "react-icons/ai";
import { BsFileEarmarkCheckFill, BsXLg } from "react-icons/bs";
import {
  FaDochub,
  FaFileExport,
  FaFileImport,
  FaFileSignature,
  FaRegComment,
} from "react-icons/fa";
import {
  FcCheckmark,
  FcDisclaimer,
  FcReadingEbook,
  FcTwoSmartphones,
} from "react-icons/fc";
import { TbTimelineEvent } from "react-icons/tb";

export const IconName = {
  /**
   * แก้ไข ส่งอ่าน
   */
  PATIENT_EDITOR: { id: 1, text: "แก้ไข/ส่งอ่าน" },
  PRINT_REPORT: { id: 2, text: "พิมพ์ผล" },
  FINAL_DIAG_INFORM: { id: 3, text: "แจ้ง Final Diagnosis" },
  MARK_AS_VERIFY: { id: 4, text: "Marks as Verified" },
  CHECK_STUDY_PROGRESS: { id: 5, text: "ตรวจสอบ TIME-LINE" },
  PAST_EXTERNAL_REPORT: { id: 6, text: "วางผลจากภายนอก (ปิดเคส)" },
  STUDY_REVIEWS: { id: 7, text: "ส่ง REVIEW อีกครั้ง" },
  BILLING_ISSUED: { id: 8, text: "ออกเอกสาร" },
  SET_OLD_STUDY: { id: 9, text: "ส่ง Study เก่า" },
  CANCEL_STUDY: { id: 10, text: "ยกเลิกเคส" },

  /** Radiologirst Toggle Menu */
  RADI_ACCEPT_CASE: { id: 20, text: "รับเคส" },
  RADI_REJECT_CASE: { id: 22, text: "ปฏิเสธ" },
  RADI_DIAG_REPORT: { id: 21, text: "อ่านผล" },
  RADI_EDIT_REPORT: { id: 23, text: "แก้ไขผล" },
  RADI_CONFERRENCE: { id: 24, text: "แจ้ง CONFERRENCE" },
  RADI_INFORM_PROBLEM: { id: 25, text: "แจ้งปัญหา" },
  /** Common Use */
  RETURN_NOACTION: { id: 31, text: "กลับ" },
};

const styles = {
  icon: { color: "#2731ff", marginRight: "15px" },
  listItem: { color: "#242323", padding: "5px" },
  buttonFilter: { marginRight: "2px" },
};
/**
 *
 * @param {*} iconName
 * @param {*} style
 * @returns
 */
export const GetMenu = (icon, style) => {
  // console.log("The icon is ", icon);
  switch (icon.id) {
    case IconName.PATIENT_EDITOR.id:
      return <AiFillEdit style={styles.icon} />;
    case IconName.PRINT_REPORT.id:
      return <AiFillPrinter style={styles.icon} />;
    case IconName.FINAL_DIAG_INFORM.id:
      return <AiOutlineSafety style={styles.icon} />;
    case IconName.MARK_AS_VERIFY.id:
      return <BsFileEarmarkCheckFill style={styles.icon} />;
    case IconName.CHECK_STUDY_PROGRESS.id:
      return <TbTimelineEvent style={styles.icon} />;
    case IconName.PAST_EXTERNAL_REPORT.id:
      return <FaFileImport style={styles.icon} />;
    case IconName.STUDY_REVIEWS.id:
      return <FaFileExport style={styles.icon} />;
    case IconName.BILLING_ISSUED.id:
      return <FaDochub style={styles.icon} />;
    case IconName.SET_OLD_STUDY.id:
      return <AiOutlineDiff style={styles.icon} />;
    case IconName.CANCEL_STUDY.id:
      return <BsXLg style={styles.icon} />;

    case IconName.RADI_ACCEPT_CASE.id:
      return <FcCheckmark style={styles.icon} />;

    case IconName.RADI_DIAG_REPORT.id:
      return <FcReadingEbook style={styles.icon} />;

    case IconName.RADI_EDIT_REPORT.id:
      return <FaFileSignature style={styles.icon} />;

    case IconName.RADI_CONFERRENCE.id:
      return <FcTwoSmartphones style={styles.icon} />;

    case IconName.RADI_INFORM_PROBLEM.id:
      return <FaRegComment style={styles.icon} />;

    case IconName.RADI_REJECT_CASE.id:
      return <FcDisclaimer style={styles.icon} />;
    case IconName.RETURN_NOACTION.id:
      return <AiFillCloseCircle style={styles.icon} />;

    default:
      return <AiFillEdit style={styles.icon} />;
  }
};

export const BuildMenuItem = (icon, onClick, disabled) => {
  return { icon: icon, onClick: onClick, disabled };
};

/**
 * Create Context-Menu container
 * @param {} menuItems
 * @returns
 */
export const BuildContextItem = (menuItems) =>
  new Promise((resolve, reject) => {
    //if (menuItems == null) resolve([]);
    resolve(
      <Popover id="popover-basic" style={{ minWidth: "300px" }}>
        <Popover.Header
          style={{ background: "#1907a2", color: "#f4f4ff" }}
          as="h3"
        >
          เลือกรายการ
        </Popover.Header>
        <Popover.Body style={{ pading: "0 0 0 0px" }}>
          {menuItems.map((item, i) => (
            <ListGroup.Item
              style={styles.listItem}
              action
              variant="light"
              disabled={item.disabled}
              hidden={item.hidden}
              onClick={item.onClick}
            >
              {GetMenu(item.icon)}
              {item.icon.text}
            </ListGroup.Item>
          ))}
        </Popover.Body>
      </Popover>
    );
  });

//  // ------------ OLD Popup Menu ------
//  const popover = (
//   <Popover id="popover-basic" style={{ minWidth: "300px" }}>
//     <Popover.Header
//       style={{ background: "#1907a2", color: "#f4f4ff" }}
//       as="h3"
//     >
//       เลือกรายการ
//     </Popover.Header>
//     <Popover.Body style={{ pading: "0 0 0 0px" }}>
//       <ListGroup style={{ margin: "0 0 0 0px", padding: "0 0 0 0px" }}>
//         <ListGroup.Item
//           style={styles.listItem}
//           action
//           variant="light"
//           disabled={selectedRow?.is_study_old === "y" ? true : false}
//           onClick={() => {
//             showEditorAction(false);
//           }}
//         >
//           <AiFillEdit style={styles.icon} /> แก้ไข/ส่งอ่าน
//         </ListGroup.Item>

//         <ListGroup.Item
//           onClick={() => showResultAction()}
//           style={styles.listItem}
//           action
//           variant="light"
//           hidden={selectedRow?.rad_resulted !== "y"}
//         >
//           <AiFillPrinter style={styles.icon} /> พิมพ์ผล
//         </ListGroup.Item>

//         {/* <ListGroup.Item style={styles.listItem} action variant="light">
//           <AiOutlineSolution style={styles.icon}/> ส่งอ่านผล
//           </ListGroup.Item>
//         */}
//         <ListGroup.Item style={styles.listItem} action hidden variant="light">
//           <AiOutlineSafety style={styles.icon} />
//           แจ้ง Final Diagnosis
//         </ListGroup.Item>

//         <ListGroup.Item
//           onClick={() => {
//             ConfirmsRemoveCase();
//           }}
//           style={styles.listItem}
//           action
//           variant="light"
//           hidden={selectedRow?.diag_finish == "y"}
//         >
//           <BsXLg style={{ ...styles.icon, color: "#f82020" }} /> ยกเลิกเคส
//         </ListGroup.Item>

//         <ListGroup.Item
//           onClick={() => ConfirmsVerifiedCase(false)}
//           style={styles.listItem}
//           action
//           variant="light"
//           hidden={selectedRow?.diag_finish !== "y"}
//         >
//           <BsFileEarmarkCheckFill
//             style={{ ...styles.icon, color: "#1bec08" }}
//           />
//           Marks as Verified
//         </ListGroup.Item>

//         <ListGroup.Item
//           style={styles.listItem}
//           onClick={(e) => {
//             showEditorAction(true);
//           }}
//           action
//           variant="light"
//           hidden={
//             selectedRow?.diag_finish == "y" ||
//             selectedRow?.rad_accepted == "y"
//           }
//         >
//           <AiOutlineDiff style={styles.icon} />
//           ส่ง Study เก่า
//         </ListGroup.Item>
//         <ListGroup.Item
//           style={styles.listItem}
//           onClick={(e) => {
//             setStudyTrack({
//               show: true,
//               data: {
//                 PacsStudyId: selectedRow?.pacs_study_id ?? 0,
//               },
//             });
//             setShowCtx(false);
//           }}
//           action
//           variant="light"
//           // hidden={selectedRow?.diag_finish == "y"}
//         >
//           <TbTimelineEvent style={styles.icon} />
//           ดูความคืบหน้าเคส
//         </ListGroup.Item>

//         <ListGroup.Item
//           style={styles.listItem}
//           onClick={(e) => {
//             setExternalResulting({
//               show: true,
//               data: selectedRow,
//               action: (e) => {
//                 getData(false);
//               },
//             });
//             setShowCtx(false);
//           }}
//           action
//           variant="light"
//           hidden={
//             selectedRow?.diag_finish == "y" ||
//             selectedRow?.is_study_old == "y" ||
//             selectedRow?.rad_accepted == "y"
//           }
//         >
//           <FaFileImport style={styles.icon} />
//           วางผลจากภายนอก (ปิดเคส)
//         </ListGroup.Item>
//         <ListGroup.Item
//           style={styles.listItem}
//           onClick={() => ConfirmsReviewCase(false)}
//           action
//           variant="light"
//           hidden={
//             selectedRow?.diag_finish == "n" ||
//             selectedRow?.is_study_old == "y"
//           }
//         >
//           <FaFileImport style={styles.icon} />
//           ส่ง Review อีกครั้ง
//         </ListGroup.Item>
//         <ListGroup.Item
//           style={styles.listItem}
//           onClick={() => InvoiceHandler()}
//           action
//           variant="light"
//           hidden={selectedRow?.is_study_old == "y"}
//         >
//           <FaDochub style={styles.icon} />
//           ออกเอกสาร
//         </ListGroup.Item>
//       </ListGroup>
//     </Popover.Body>
//   </Popover>
// );

// const columns = [
//   {
//     dataField: "study_date",
//     text: "วันทำเคส",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#12ee1d",
//       null,
//       "11px",
//       "Tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     // formatter: getDateFormat,
//     formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
//   },
//   {
//     dataField: "patientid",
//     text: "HN",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("100px", null, "niramit", "18px"),
//     // style: () => getCellStyle("center"),
//     style: getCellStyle("center", null, null, "18px", "niramit"),
//     filter: textFilter(customTextFilter),
//   },
//   {
//     dataField: "patients_name",
//     text: "ชื่อ-สกุล ผู้ป่วย",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("auto", null, "niramit", "18px"),
//     style: () => getCellStyle("left", null, null, "18px", "niramit"),
//     filter: textFilter(customTextFilter),
//   },
//   {
//     dataField: "patients_sex",
//     text: "เพศ",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("50px", null, "niramit", "18px"),
//     style: () => getCellStyle("center"),
//     filter: textFilter(customTextFilter),
//     formatter: Gender,
//   },
//   {
//     dataField: "modality",
//     text: "Modality",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: () => getCellStyle("center"),
//     filter: textFilter(customTextFilter),
//   },

//   {
//     dataField: "study_description",
//     text: "Description",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("auto", null, "niramit", "18px"),
//     style: () => getCellStyle("left", null, null, "18px", "niramit"),
//     filter: textFilter(customTextFilter),
//   },
//   {
//     dataField: "urgenttype_name",
//     text: "ความด่วน",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("70px", null, "niramit", "18px"),
//     // style: () => getCellStyle("center", null, null, "18px", "niramit"),
//     formatter: UrgentType,
//     style: getCellStyle(
//       "center",
//       "#07d4f8",
//       null,
//       "18px",
//       "niramit",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//   },

//   {
//     dataField: "radi_nickname",
//     text: "รังสีแพทย์",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#f807c4",
//       null,
//       "18px",
//       "niramit",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//   },

//   {
//     dataField: "upload_date",
//     text: "ส่งอ่าน",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#ceccc7",
//       null,
//       "11px",
//       "tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: getDateTimeFormat,
//   },
//   // result_expected
//   {
//     dataField: "result_expected",
//     text: "นัดรับผล",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("75px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#f3bc08",
//       null,
//       "11px",
//       "tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: getDateTimeFormat,
//   },
//   {
//     dataField: "radi_received_time",
//     text: "พ.รับเคส",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#f807c4",
//       null,
//       "11px",
//       "tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: getDateTimeFormat,
//   },
//   {
//     dataField: "radi_finalized_time",
//     text: "พ.ส่งผล",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#0cf00c",
//       null,
//       "11px",
//       "tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: getDateTimeFormat,
//   },
//   {
//     dataField: "remaining_time",
//     text: CreateTooltip("เวลาคงเหลือ", <AiFillClockCircle />),
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px"),
//     style: getCellStyle(
//       "center",
//       "#fc2c08",
//       null,
//       "11px",
//       "tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: (cell, row) =>
//       row.is_study_old == "n" ? (
//         ConvertMinutesToTimeRemain(row.remaining_time)
//       ) : (
//         <></>
//       ),
//   },

//   {
//     dataField: "test",
//     text: CreateTooltip(
//       "File Upload Status",
//       <div>
//         <img src={XrayImage} style={{ width: "40px", height: "50px" }} />
//       </div>
//     ),
//     style: getCellStyle("center"),
//     headerStyle: () => getHeaderStyle("80px", null, null, "middle"),
//     formatter: (x, row) => DicomStatusHeader(x, row),
//   },

//   {
//     dataField: "action_event",
//     text: CreateTooltip(
//       "Diagnosis Status",
//       <div>
//         <FcReadingEbook size={60} />
//       </div>
//     ),
//     headerStyle: () => getHeaderStyle("120px"),
//     style: getCellStyle("center", null, null, "16px", "niramit"),
//     formatter: formatStatus,
//     align: "center",
//   },
//   {
//     dataField: "diag_verified",
//     text: CreateTooltip(
//       "Verified",
//       <div>
//         <FcInspection size={50} />
//       </div>
//     ),

//     headerStyle: () => getHeaderStyle("50px"),
//     style: getCellStyle("center"),
//     formatter: formatVerified,
//     align: "center",
//   },
// ];

// const columns2 = [
//   {
//     dataField: "study_date",
//     text: "วันทำเคส",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#12ee1d",
//       null,
//       "11px",
//       "Tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
//   },
//   {
//     dataField: "patientid",
//     text: "HN",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("100px", null, "niramit", "18px"),
//     // style: () => getCellStyle("center"),
//     style: getCellStyle("center", null, null, "18px", "niramit"),
//     filter: textFilter(customTextFilter),
//   },
//   {
//     dataField: "patients_name",
//     text: "ชื่อ-สกุล ผู้ป่วย",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("auto", null, "niramit", "18px"),
//     style: () => getCellStyle("left", null, null, "18px", "niramit"),
//     filter: textFilter(customTextFilter),
//   },
//   {
//     dataField: "patients_sex",
//     text: "เพศ",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("50px", null, "niramit", "18px"),
//     style: () => getCellStyle("center"),
//     filter: textFilter(customTextFilter),
//     formatter: Gender,
//   },
//   {
//     dataField: "modality",
//     text: "Modality",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: () => getCellStyle("center"),
//     filter: textFilter(customTextFilter),
//   },

//   {
//     dataField: "study_description",
//     text: "Description",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("auto", null, "niramit", "18px"),
//     style: () => getCellStyle("left", null, null, "18px", "niramit"),
//     filter: textFilter(customTextFilter),
//   },
//   {
//     dataField: "urgenttype_name",
//     text: "ความด่วน",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     // style: () => getCellStyle("center", null, null, "18px", "niramit"),
//     style: getCellStyle(
//       "center",
//       "#07d4f8",
//       null,
//       "18px",
//       "niramit",
//       "1px solid #484947"
//     ),
//     formatter: UrgentType,
//     filter: textFilter(customTextFilter),
//   },

//   {
//     dataField: "radi_nickname",
//     text: "รังสีแพทย์",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#07d4f8",
//       null,
//       "18px",
//       "niramit",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//   },

//   {
//     dataField: "upload_date",
//     text: "ส่งอ่าน",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       null,
//       null,
//       "11px",
//       "tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: getDateTimeFormat,
//   },
//   // result_expected
//   {
//     dataField: "result_expected",
//     text: "นัดรับผล",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#adf308",
//       null,
//       "11px",
//       "tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: getDateTimeFormat,
//   },
//   {
//     dataField: "radi_received_time",
//     text: "พ.รับเคส",
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px", null, "niramit", "18px"),
//     style: getCellStyle(
//       "center",
//       "#0cf00c",
//       null,
//       "11px",
//       "tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: getDateTimeFormat,
//   },
//   {
//     dataField: "remaining_time",
//     text: CreateTooltip("เวลาคงเหลือ", <AiFillClockCircle />),
//     sort: true,
//     headerStyle: () => GetHeaderStyle("80px"),
//     style: getCellStyle(
//       "center",
//       "#fc2c08",
//       null,
//       "11px",
//       "tahoma",
//       "1px solid #484947"
//     ),
//     filter: textFilter(customTextFilter),
//     formatter: (cell, row) => ConvertMinutesToTimeRemain(row.remaining_time),
//   },

//   {
//     dataField: "test",
//     text: CreateTooltip(
//       "File Upload Status",
//       <div>
//         <img src={XrayImage} style={{ width: "40px", height: "50px" }} />
//       </div>
//     ),
//     style: getCellStyle("center"),
//     headerStyle: () => getHeaderStyle("80px", null, null, "middle"),
//     formatter: (x, row) => DicomStatusHeader(x, row),
//   },

//   {
//     dataField: "action_event",
//     text: CreateTooltip(
//       "Diagnosis Status",
//       <div>
//         <FcReadingEbook size={60} />
//       </div>
//     ),
//     headerStyle: () => getHeaderStyle("120px"),
//     style: getCellStyle("center", null, null, "16px", "niramit"),
//     formatter: formatStatus,
//     align: "center",
//   },
// ];
